import { admins_api_complaint_url } from 'mk/urls/functions';
import { ComplaintFormData } from 'mk2/containers/Complaint/ComplaintForm';

export function saveComplaint(xhr, entity: string, id: number, complaint: ComplaintFormData) {
    return xhr.post(admins_api_complaint_url(entity, id), { ...complaint });
}
